import { AxiosAdapter } from '../../_config/adapters/axios/axios.adapter';
import { Http } from '../../_config/adapters/axios/axios.protocols';
import { ENVIROMENT } from '../../v2-config/constants/enviroments.constant';
import { loadReadNotificationsCache, saveReadNotificationsCache } from '../../_config/functions/save-read-notificacations-on-storage';


export class Service {
	async checkNotification({ typeId, token, pharmacy }) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${ENVIROMENT.NOTIFICATION_V2}/notification/check-status-and-update`,
			data: { pharmacy, type_id: typeId },
			headers: { Authorization: `Bearer ${token}` },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}

// Función helper para uso directo
export async function checkNotificationAndMarkAsRead({ typeId, token, pharmacy }) {
	try {
		const service = new Service();
		return await service.checkNotification({ typeId, token, pharmacy });
	} catch (error) {
		console.error('Error checking notification:', error);
	}
}

export const handleNotificationClick = async (typeId, pharmacy) => {
  const user = JSON.parse(localStorage.getItem('userInfo'));
	const readOrdersCache = loadReadNotificationsCache();
	if (readOrdersCache[typeId]) {
		console.log('La orden ya fue leída:', typeId);
		return;
	}
	try {
		console.log('Marcando notificación de tipo orden como leída:', typeId);
		const response = await checkNotificationAndMarkAsRead({
			typeId: typeId,
			token: user?.token,
			pharmacy: pharmacy,
		});
		console.log('Notification checked and marked as read:', response);
		readOrdersCache[typeId] = true;
		saveReadNotificationsCache(readOrdersCache);
	} catch (error) {
		console.log('Error marcando notificación de tipo orden como leída:', error);
	}
};
